<template lang="pug">
  div
    h3.form-title.text-center ยืนยันข้อมูลการสมัคร
    step1
    Step2

    footer.form-footer
      .d-flex.justify-content-center
        button.back(@click="$store.commit('SET_STEP', 4)") กลับสู่ก่อนหน้า
        button.finish ยืนยันการสมัครงาน
</template>
<script>
import Step1 from '../components/step5/Step1.vue'
import Step2 from '../components/step5/Step2.vue'
export default {
  components: { Step1, Step2 }
}
</script>

<style lang="scss">
.result {
  padding: 2rem;
  background: #f5fbfe;

  &-item {
    font-size: 18px;
    padding: 0.5rem 0;

    strong {
      white-space: nowrap;
      color: #58595B;
    }

    span {
      color: #19499c;
    }
  }

  &-title {
    margin-bottom: 2rem;
  }
}
</style>